import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";

const fetchAutomationHealth = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails)
    throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios
    .get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getAutomationHealth&companyid=${user.companyid}`
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error?.response?.data?.error);
      throw error;
    });

  return response;
};

const useAutomationHealthQuery = (options = {}) => {
  return useMutation({
    mutationFn: fetchAutomationHealth,
    ...options,
  });
};

export default useAutomationHealthQuery;